"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyRowFieldChange = applyRowFieldChange;
exports.applyRowSelectChange = applyRowSelectChange;
exports.deleteRow = deleteRow;
exports.summarizeRowOps = summarizeRowOps;
function deleteRow(rows, index) {
  const row = rows[index];
  if (!row) return;
  if (row.entryNode) {
    row.status = 'deleted';
    return;
  }
  rows.splice(index, 1);
}
function applyRowSelectChange(row, field, nextValue) {
  row[field] = nextValue.trim();
  if (row.entryNode) {
    row.status = row.status === 'existing' || row.status === 'deleted' ? 'modified' : row.status;
    return;
  }
  row.status = 'new';
}
function summarizeRowOps(rows, rowHasContent) {
  const create = rows.filter(row => row.status === 'new' && rowHasContent(row));
  const update = rows.filter(row => row.status === 'modified' && rowHasContent(row));
  const remove = rows.filter(row => row.status === 'deleted');
  return {
    create,
    update,
    remove
  };
}

/* The following function was generated by AI Model: GPT-5.3-Codex  */
/* it was originally only for addresses but I made it more generic so it can be used for any type of rows */
/* Prompt: can you have applyAddressFieldChange update the row status based on whether any fields have content */
function applyRowFieldChange(row, field, nextValue, hasContent) {
  row[field] = nextValue;
  if (!hasContent(row)) {
    row.status = row.entryNode ? 'deleted' : 'new';
    return;
  }
  if (row.entryNode) {
    row.status = row.status === 'existing' || row.status === 'deleted' ? 'modified' : row.status;
    return;
  }
  row.status = 'new';
}